import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1641997825980-cbaf406765db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await register(form.name, form.email, form.password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-24 lg:order-1">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-clay">Junte-se ao círculo</p>
          <h1 className="mt-3 font-serif text-4xl font-light text-forest-deep">Criar conta</h1>
          <form onSubmit={submit} className="mt-8 space-y-5">
            {error && <p data-testid="register-error" className="border border-clay/40 bg-clay/10 px-4 py-3 font-sans text-sm text-clay">{error}</p>}
            <div>
              <label className="font-mono text-[10px] uppercase tracking-widest text-ink/60">Nome completo</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" required
                className="mt-1 w-full border border-borderlight bg-white px-4 py-3 font-sans text-sm outline-none focus:border-clay" />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-widest text-ink/60">E-mail</label>
              <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" required
                className="mt-1 w-full border border-borderlight bg-white px-4 py-3 font-sans text-sm outline-none focus:border-clay" />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-widest text-ink/60">Senha</label>
              <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" required
                className="mt-1 w-full border border-borderlight bg-white px-4 py-3 font-sans text-sm outline-none focus:border-clay" />
            </div>
            <button type="submit" disabled={busy} data-testid="register-submit"
              className="w-full bg-forest-deep py-4 font-mono text-xs uppercase tracking-[0.2em] text-alabaster transition-colors hover:bg-clay disabled:opacity-50">
              {busy ? "Criando..." : "Criar conta"}
            </button>
          </form>
          <p className="mt-6 font-sans text-sm text-ink/60">
            Já tem conta? <Link to="/login" data-testid="go-login" className="text-clay hover:underline">Entrar</Link>
          </p>
        </motion.div>
      </div>
      <div className="relative hidden lg:block">
        <img src={HERO} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest-deep/40" />
        <div className="absolute bottom-12 right-12 text-right">
          <span className="font-serif text-5xl text-alabaster">Vérité Botanica</span>
        </div>
      </div>
    </div>
  );
}
